import {isDevelopment} from "../utils/isDevelopment";
isDevelopment() && console.log("*** Development Mode ***");
export const PROD_URL = 'https://vuelve-server.fly.dev/';
export const LOCAL_URL = 'http://localhost:3001/'
export const isProd = !isDevelopment();

export const BASE_URL = isDevelopment() ? LOCAL_URL : PROD_URL;
// export const BASE_URL = LOCAL_URL;